import { useMemo } from "react";
import { ToastContainer } from "react-toastify";
import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import { PhantomWalletAdapter } from "@solana/wallet-adapter-wallets";
import { clusterApiUrl } from "@solana/web3.js";

import { WalletModalProvider } from "@solana/wallet-adapter-react-ui";

import {
  ApolloClient,
  ApolloProvider,
  InMemoryCache,
  HttpLink,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { Provider } from "react-redux";
import { socket, SocketContext } from "@context/socket";

import store from "@redux/stores/store";

import "react-toastify/dist/ReactToastify.css";
require("@solana/wallet-adapter-react-ui/styles.css");

import Main from "./Main";

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_BACKEND_SERVER || "",
});
const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem("token");
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

function App() {
  // Can be set to 'devnet', 'testnet', or 'mainnet-beta'
  const network = WalletAdapterNetwork.Devnet;

  // You can also provide a custom RPC endpoint
  const endpoint = useMemo(() => clusterApiUrl(network), [network]);

  // @solana/wallet-adapter-wallets includes all the adapters but supports tree shaking --
  // Only the wallets you configure here will be compiled into your application
  const wallets = useMemo(() => [new PhantomWalletAdapter()], [network]);

  return (
    <ApolloProvider client={client}>
      <SocketContext.Provider value={socket}>
        <Provider store={store}>
          <ConnectionProvider endpoint={endpoint}>
            <WalletProvider wallets={wallets}>
              <WalletModalProvider>
                <Main />
                <ToastContainer
                  position="bottom-right"
                  autoClose={3000}
                  pauseOnHover={true}
                  closeOnClick={true}
                />
              </WalletModalProvider>
            </WalletProvider>
          </ConnectionProvider>
        </Provider>
      </SocketContext.Provider>
    </ApolloProvider>
  );
}

export default App;
